import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MenuItem, ConfirmationService, Message, SelectItem } from 'primeng/primeng';

import { PadraoService } from '../service/padrao.service';
import { BaseComponent } from './base.component';

@Component({ template: '' })
export class BaseCrudComponent extends BaseComponent implements OnInit {
    cadastro: FormGroup;
    obj: any;

    filtro: FormGroup;

    id: number;
    acao: string;

    showEtapas: boolean = false;

    disableAutoLoad: boolean = false;

    etapa: number = 0;
    etapas: MenuItem[] = [
        { label: 'Dados' },
        { label: 'Resumo' }
    ];

    dateValidation: RegExp = /(((\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2}))([+-](\d{2})\:(\d{2}))?Z?z?)/;

    /**
     * Variavel responsavel por identificar se a funcionalidade usa navegação customizada.
     */
    customValidator: boolean = false;
    /**
     * Objeto usado para realizar a validação em multiplos níveis em uma telas, deve ser definido na classe que extende o base-crud.
     */
    multiValidator = {
        cadastro: this.cadastro,
        isValid: false,
        /**
         * Metodo a ser definido na implementação do multiValidator;
         */
        emitValidation: (isInit: any) => this.emitValidation(isInit)
    };

    ngOnInit() {
        this.ngProgress.start();
        this.ngProgress.done();
        this.init();
        // this.activatedRoute.data.subscribe(data => {
        //     console.log('data', data)
        // //     if (Object.keys(data).length > 0)
        // //         this.filtro.patchValue(data);
        // });
        this.activatedRoute.params.subscribe(params => {
            this.id = params['id'];
            var listaLink = location.href.split("/")
            var caminho = listaLink[5] + '/' + listaLink[6];
            if (caminho === "turma/editar") {
                this.acao = 'turma-editar';
            } else if (caminho === "turma/prestar-conta") {
                this.acao = 'turma-prestar-conta'
            } else {
                this.acao = (params['acao'] !== undefined ? params['acao'] : "cadastrar").toLowerCase();
            }

            switch (this.acao) {
                case 'visualizar':
                    this.etapa = (this.etapas.length - 1);
                    this.cadastro.disable();
                case 'enviar-cadastro':
                    this.etapa = (this.etapas.length - 1);
                case 'alterar-responsavel':
                    this.loadObject();
                    break;
                case 'editar':
                    this.loadObject();
                    break;
                case 'turma-prestar-conta':
                    this.loadObject();
                    break;
                case 'turma-editar':
                    this.loadObject();
                    break;
            };
        });
        this.afterInit();
    };

    loadObject() {
        if (!this.disableAutoLoad) {
            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.service.Obter(this.controllerName, this.id).subscribe(obj => {
                if (obj == null) { alert('id: \'' + this.id + '\' não encontrado no banco'); return; } //todo: welton.lago - url retornou null - http://localhost:4200/#/usuarios/usuario-externo/editar/1830652 - melhorar tratamento (estrutural)
                Object.keys(obj).forEach(key => {
                    obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                });
                this.obj = obj;
                this.cadastro.patchValue(obj);
                this.afterLoad();
            },
                err => {
                    this.showMsg('error', 'Erro', `Erro ao obter registro. ${err._body}`);
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                },
                () => this.observableUtilPanelDoc.setBlockedPanel(false));
        };
    }

    doFinalAction(obj: any, route: string = null) {
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, os dados serão ${this.acao == 'cadastrar' ? 'salvos' : 'atualizados'} na base de dados.<br>Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.acao == 'cadastrar' ?
                    this.service.Adicionar(route == null ? this.controllerName : route, obj).subscribe(() => this.router.navigate(['../'], { relativeTo: this.activatedRoute }), err => this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao salvar o registro.<br> ${err._body}`)) :
                    this.service.Atualizar(route == null ? this.controllerName : route, obj).subscribe(() => this.router.navigate(['../../'], { relativeTo: this.activatedRoute }), err => this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao atualizar o registro.<br> ${err._body}`));
            }
        });
    }

    ngAfterContentChecked() {
        if (this.contentCheck++ > 4)
            this.observableUtilPanel.setBlockedPanel(false);
    }
}


// WEBPACK FOOTER //
// ./src/app/base/base-crud.component.ts